<form [formGroup]="form" novalidate>
    <div class="file-drop-area">
        
        <div class="file-add" *ngIf="!formData[id]" (click)="add()">
            <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="64px-Line" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="img-plus"></g>
                    <path d="M45,32 C37.832,32 32,37.832 32,45 C32,52.168 37.832,58 45,58 C52.168,58 58,52.168 58,45 C58,37.832 52.168,32 45,32 L45,32 Z M45,56 C38.935,56 34,51.065 34,45 C34,38.935 38.935,34 45,34 C51.065,34 56,38.935 56,45 C56,51.065 51.065,56 45,56 L45,56 Z" id="Shape" fill="#000000"></path>
                    <path d="M51,44 L46,44 L46,39 C46,38.448 45.553,38 45,38 C44.447,38 44,38.448 44,39 L44,44 L39,44 C38.447,44 38,44.448 38,45 C38,45.552 38.447,46 39,46 L44,46 L44,51 C44,51.552 44.447,52 45,52 C45.553,52 46,51.552 46,51 L46,46 L51,46 C51.553,46 52,45.552 52,45 C52,44.448 51.553,44 51,44 L51,44 Z" id="Shape" fill="#000000"></path>
                    <path d="M5,46 L29,46 C29.553,46 30,45.552 30,45 C30,44.448 29.553,44 29,44 L6,44 L6,10 L52,10 L52,31.146 C52,31.698 52.447,32.146 53,32.146 C53.553,32.146 54,31.698 54,31.146 L54,9 C54,8.448 53.553,8 53,8 L5,8 C4.447,8 4,8.448 4,9 L4,45 C4,45.552 4.447,46 5,46 L5,46 Z" id="Shape" fill="#000000"></path>
                    <path d="M20,19 C20,16.243 17.757,14 15,14 C12.243,14 10,16.243 10,19 C10,21.757 12.243,24 15,24 C17.757,24 20,21.757 20,19 L20,19 Z M12,19 C12,17.346 13.346,16 15,16 C16.654,16 18,17.346 18,19 C18,20.654 16.654,22 15,22 C13.346,22 12,20.654 12,19 L12,19 Z" id="Shape" fill="#000000"></path>
                    <path d="M42.272,29.686 C42.663,30.077 43.295,30.077 43.686,29.686 C44.077,29.295 44.077,28.663 43.686,28.272 L37.707,22.293 C37.316,21.902 36.684,21.902 36.293,22.293 L27,31.586 L21.707,26.293 C21.316,25.902 20.684,25.902 20.293,26.293 L8.293,38.293 C7.902,38.684 7.902,39.316 8.293,39.707 C8.488,39.902 8.744,40 9,40 C9.256,40 9.512,39.902 9.707,39.707 L21,28.414 L28.293,35.707 C28.684,36.098 29.316,36.098 29.707,35.707 C30.098,35.316 30.098,34.684 29.707,34.293 L28.414,33 L37,24.414 L42.272,29.686 L42.272,29.686 Z" id="Shape" fill="#000000"></path>
                </g>
            </svg>
        </div>

        <div class="file-msg" *ngIf="formData[id]">
            <img src="{{formData[id].small}}"/>

            <div class="remove" (click)='remove()'>
                <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="64px-Line" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="cha-multiply"></g>
                        <path d="M31,6 C16.112,6 4,18.112 4,33 C4,47.888 16.112,60 31,60 C45.888,60 58,47.888 58,33 C58,18.112 45.888,6 31,6 L31,6 Z M31,58 C17.215,58 6,46.785 6,33 C6,19.215 17.215,8 31,8 C44.785,8 56,19.215 56,33 C56,46.785 44.785,58 31,58 L31,58 Z" id="Shape" fill="#000000"></path>
                        <path d="M42.707,21.293 C42.316,20.902 41.684,20.902 41.293,21.293 L31,31.586 L20.707,21.293 C20.316,20.902 19.684,20.902 19.293,21.293 C18.902,21.684 18.902,22.316 19.293,22.707 L29.586,33 L19.293,43.293 C18.902,43.684 18.902,44.316 19.293,44.707 C19.488,44.902 19.744,45 20,45 C20.256,45 20.512,44.902 20.707,44.707 L31,34.414 L41.293,44.707 C41.488,44.902 41.744,45 42,45 C42.256,45 42.512,44.902 42.707,44.707 C43.098,44.316 43.098,43.684 42.707,43.293 L32.414,33 L42.707,22.707 C43.098,22.316 43.098,21.684 42.707,21.293 L42.707,21.293 Z" id="Shape" fill="#000000"></path>
                    </g>
                </svg>
            </div>
        </div>

        <div class='error' style='padding-top:2.0em;' *ngIf="errorMessage || region.invalid">
            <div *ngIf="errorMessage">{{errorMessage}}</div>

            <div *ngIf="region.invalid && (region.dirty || region.touched)" class="error">
                <div *ngIf="region.errors.required">Please select a Region for this Course</div>
            </div>
            
        </div>
        
        <div style='text-align: left; padding-top:2.0em;' *ngIf="isLoaded && display && !queue"> 
            <div>
                Assign an image to this course by selecting one of the images below. If you have additional images to upload please contact info@ncahec.net.
            </div>
            
            <div style='margin-top:1.0em;'>
                
                Each image below matches one of the following criteria:
                <div style='margin-top:0.5em;'>- Tagged with Region "{{regionDisplayName}}"</div>
                <div style='margin-top:0.5em;'>- Offered as a state-wide image resource</div>
            </div>
            
            <div style='margin-top:1.0em'>
                <label>
                    Keywords
                    <div class="details">Filter results further by selecting a Keyword</div>
                </label>

                <ng-select id="keyword" formControlName="keyword" [items]="courseTaxonomy" bindValue="id" bindLabel="name" placeholder="Select Keyword" [multiple]></ng-select>
            </div>

            <div style='margin-top:2.0em;'>
                <div *ngIf="!isLoading && !total">
                    There are no images which match the search criteria provided.
                </div>

                <div *ngIf="total">
                    <div class="row" style='margin-top:1.0em;'>
                        <div class="col-sm-12">
                            There {{ total !== 1 ? "are" : "is"}} {{ total | number }} image option{{total !== 1?"s":""}} available for this course.
                        </div>

                        <ng-template ngFor let-file [ngForOf]="files" let-i="index" [ngForTrackBy]="trackById">
                            <div class="result col-xs-6 col-sm-4 col-md-3">
                                <img src="{{file.small}}" (click)="select(file)"/>
                            </div>

                            <div class="clearfix visible-xs-block" *ngIf="!((i+1)%2)"></div>
                            <div class="clearfix visible-sm-block" *ngIf="!((i+1)%3)"></div>
                            <div class="clearfix visible-md-block visible-lg-block" *ngIf="!((i+1)%4)"></div>
                        </ng-template>

                        <div class="col-sm-12 result">
                            <app-load-more *ngIf="!isLoading && !isLoadingComplete" (click)="get()"></app-load-more>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
        <app-loading [isLoading]="true" *ngIf="isLoading && display"></app-loading>

    </div>
</form>

<!-- <pre>{{formData|json}}</pre> -->